/** Sticky navbar height + breathing room for in-page scroll targets */
export function navbarOffsetPx() {
  const nav = document.querySelector('[data-testid="site-navbar"]');
  if (!nav) return 96;
  return nav.getBoundingClientRect().height + 12;
}

/** Scroll to the hero (`#home`) or page top */
export function scrollToHero(behavior = "smooth") {
  const hero = document.getElementById("home");
  if (hero) {
    const top =
      hero.getBoundingClientRect().top + window.scrollY - navbarOffsetPx();
    window.scrollTo({ top: Math.max(0, top), behavior });
    return;
  }
  window.scrollTo({ top: 0, behavior });
}

/** Scroll to an element id, accounting for the sticky navbar */
export function scrollToSection(id, behavior = "smooth") {
  const el = document.getElementById(id);
  if (!el) return;
  const top =
    el.getBoundingClientRect().top + window.scrollY - navbarOffsetPx();
  window.scrollTo({ top: Math.max(0, top), behavior });
}
